export const cleanFormattedTextAction = (html: string): string => {
  // Remove the style attribute from all elements inside the <a> tag
  return html.replace(/<a[^>]*>(.*?)<\/a>/g, (match) => {
    return match.replace(/ style="[^"]*"/g, '');
  });
};
